import { ref } from 'vue'

export function useComponent() {
  const components = ref([])
  //remove 兼容以前的老组件，不是Pg开头的就在on-ok或者on-cancel删除
  const removeComponentById = (id, remove = true) => {
    const index = components.value.findIndex((im) => im.id === id)
    if (index !== -1) {
      if (!remove && components.value[index].name.startsWith('Pg')) {
        return
      }
      components.value.splice(index, 1)
    }
  }
  const action = (params, actions, next) => {
    return new Promise(async (resolve, reject) => {
      if (components.value.findIndex((im) => im.id === params.id) !== -1) {
        reject('该动作已执行')
      }
      if (params.property?.clearTops) {
        actions.updateTopErrors?.({ errors: [] })
        actions.updateSuccess?.({ data: [] })
      }
      //是否需要校验表单
      if (params.property.validate) {
        const errors = await actions.validate?.()
        if (errors) {
          Array.isArray(errors) && actions.updateTopErrors?.({ errors })
          return reject()
        }
      }
      components.value.push({
        id: params.id,
        name: params.property.component,
        props: {
          ...params.parameter,
          key: params.id,
        },
        listeners: {
          'on-cancel': () => {
            removeComponentById(params.id, false)
            reject()
          },
          'on-error': (res) => {
            const resData = res?.headers ? res.data : res
            if (resData?.errors?.length > 0) {
              actions.updateTopErrors?.(resData)
            }
            removeComponentById(params.id, false)
            reject()
          },
          'on-ok': (res) => {
            removeComponentById(params.id, false)
            resolve(res)
          },
          'on-ok-and-continue': (res) => {
            next(res)
          },
          closed: () => {
            removeComponentById(params.id)
          },
        },
      })
    })
  }
  return {
    components,
    action,
  }
}
